import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MaterialModule } from '../modules/material/material.module';
import { InputTagComponent } from './input-tag/input-tag.component';
import { ButtonTagComponent } from './button-tag/button-tag.component';
import { CalenderTagComponent } from './calender-tag/calender-tag.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MenuComponent } from './navbar/menu/menu.component';
import { SideMenuComponent } from './navbar/side-menu/side-menu.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderInterceptorService } from '../services/loader-interceptor.service';
import { EditQuoteModalComponent } from './edit-quote-modal/edit-quote-modal.component';
// import { RadioTagComponent } from './radio-tag/radio-tag.component';
import { JsonControlService } from '../services/json-control.service';
import { CommaSepratorPipe } from '../utility/comma-separator.pipe';
import { NumberToWordsPipe } from '../utility/number-to-words.pipe';
import { InrNumWordsPipe } from '../utility/inr-num-words.pipe';
import { DomSanitizeSafeUrlPipe} from '../utility/dom-sanitize-safe-url.pipe';
import { EditPropsoalModalComponent } from './edit-propsoal-modal/edit-propsoal-modal.component';
import { PremiumBreakupComponent } from './premium-breakup/premium-breakup.component';
import { PlanDetailsComponent } from '../component/plan-details/plan-details.component';
import { InputFileTagComponent } from './input-file-tag/input-file-tag.component';
import { LimitedPayComponent } from './limited-pay/limited-pay.component';
import { SharedApiService } from '../services/shared-api.service';
import { BiPdfUrlComponent } from './bi-pdf-url/bi-pdf-url.component';
import { LoaderSpecificComponent } from './loader-specific/loader-specific.component';
import { QuotePremiumBreakupComponent } from './quote-premium-breakup/quote-premium-breakup.component';
import { ErrorHandlerComponent } from '../component/error-handler/error-handler.component';
import { StepperComponent } from './stepper/stepper.component';
import { OTPComponent } from './otp/otp.component';
// import { NgxSpinnerModule } from 'ngx-spinner';

/**
 * Do i rellay need to call in each and every modules   - Ask Suvendra sir about this
 * TODOs
 */
import {OnlyNumbersDirective} from '../directives/utils/only-numbers.directive';
import { FocusInvalidInputDirective } from '../directives/utils/focus-invalid-input.directive';
import { AnnualIncomeModalComponent } from './annual-income-modal/annual-income-modal.component';
import { ContactNumberComponent } from './contact-number/contact-number.component';
import { IciciLimitedPayComponent } from './limited-pay-detail/icici-limited-pay/icici-limited-pay.component';
import { PnbLimitedPayComponent } from './limited-pay-detail/pnb-limited-pay/pnb-limited-pay.component';
import { TataDefenceComponent } from './tata-defence/tata-defence.component';
import { TataOccupationComponent } from './tata-occupation/tata-occupation.component';
// import { IpruCovidQuestionComponent } from './ipru-covid-question/ipru-covid-question.component';
import { FatcaComponent } from './fatca/fatca.component';
import { CovidQuestionComponent } from './tata-questionniare/covid-question/covid-question.component';
import { BQPOtpComponent } from './bqp-otp/bqp-otp.component';
import { SandWatchLoaderComponent } from './sand-watch-loader/sand-watch-loader.component';
import { HypertensionComponent } from './hypertension/hypertension.component';
import { DiabetesComponent } from './diabetes/diabetes.component';
// import { TabQuestionnaireComponent} from './tab-questionnaire/tab-questionnaire.component'

/**external plugin for mbile view */

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { QuoteLoaderComponent } from './quote-loader/quote-loader.component';
import { BiModalComponent } from './bi-modal/bi-modal.component';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { ComparisonModalComponent } from './comparison-modal/comparison-modal.component';






@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        MaterialModule,
        PdfViewerModule


    ],
    declarations: [
        InputTagComponent,
        ButtonTagComponent,
        CalenderTagComponent,
        NavbarComponent,
        MenuComponent,
        SideMenuComponent,
        LoaderComponent,
        EditQuoteModalComponent,
        CommaSepratorPipe,
        NumberToWordsPipe,
        InrNumWordsPipe,
        DomSanitizeSafeUrlPipe,
        EditPropsoalModalComponent,
        PremiumBreakupComponent,
        PlanDetailsComponent,
        InputFileTagComponent,
        LimitedPayComponent,
        BiPdfUrlComponent,
        LoaderSpecificComponent,
        QuotePremiumBreakupComponent,
        ErrorHandlerComponent,
        StepperComponent,
        OTPComponent,
        OnlyNumbersDirective,
        FocusInvalidInputDirective,
        AnnualIncomeModalComponent,
        ContactNumberComponent,
        IciciLimitedPayComponent,
        PnbLimitedPayComponent,
        TataDefenceComponent,
        TataOccupationComponent,
        // IpruCovidQuestionComponent,
        FatcaComponent,
        CovidQuestionComponent,
        BQPOtpComponent,
        SandWatchLoaderComponent,
        HypertensionComponent,
        DiabetesComponent,
        QuoteLoaderComponent,
        BiModalComponent,
        UploadImageComponent,
        UploadImageComponent,
        ComparisonModalComponent
        // TabQuestionnaireComponent



        // RadioTagComponent
    ],



    entryComponents: [

        EditQuoteModalComponent,
        EditPropsoalModalComponent,
        PremiumBreakupComponent,
        PlanDetailsComponent,
        LimitedPayComponent,
        BiPdfUrlComponent,
        LoaderSpecificComponent,
        QuotePremiumBreakupComponent,
        ErrorHandlerComponent,
        StepperComponent,
        OTPComponent,
        AnnualIncomeModalComponent,
        ContactNumberComponent,
        IciciLimitedPayComponent,
        PnbLimitedPayComponent,
        BQPOtpComponent,
        BiModalComponent,
        ComparisonModalComponent
    ],

    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptorService,
            multi: true
        },
        JsonControlService,
        CommaSepratorPipe,
        NumberToWordsPipe,
        InrNumWordsPipe,
        DomSanitizeSafeUrlPipe,
        DatePipe,
        SharedApiService
        // ComponentInteractionService
    ],

    exports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
        InputTagComponent,
        ButtonTagComponent,
        CalenderTagComponent,
        NavbarComponent,
        MenuComponent,
        SideMenuComponent,
        LoaderComponent,
        CommaSepratorPipe,
        NumberToWordsPipe,
        InrNumWordsPipe,
        DomSanitizeSafeUrlPipe,
        PlanDetailsComponent,
        InputFileTagComponent,
        LimitedPayComponent,
        BiPdfUrlComponent,
        LoaderSpecificComponent,
        StepperComponent,
        OTPComponent,
        OnlyNumbersDirective,
        FocusInvalidInputDirective,
        TataDefenceComponent,
        TataOccupationComponent,
        // IpruCovidQuestionComponent,
        FatcaComponent,
        CovidQuestionComponent,
        BQPOtpComponent,
        SandWatchLoaderComponent,
        HypertensionComponent,
        DiabetesComponent,
        PdfViewerModule,
        QuoteLoaderComponent,
        UploadImageComponent

        // BiComponentInteractionDirective

        // RadioTagComponent
    ],

})
export class ComponentModule { }
